var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { hot } from 'react-hot-loader/root';
import styled from 'styled-components';
import { Header } from './header';
import { MainSection } from './main-section';
import { CountersSection } from './counters-section';
import { EarnSection } from './earn-section';
import { ServicesSection } from './services-section';
import { PanelLandingSection } from './panel-landing-section';
import { JoinSection } from './join-section';
import { Footer } from './footer';
var BotsLandingApp = function () { return (React.createElement(Container, null,
    React.createElement(Header, null),
    React.createElement(MainSection, null),
    React.createElement(CountersSection, null),
    React.createElement(EarnSection, null),
    React.createElement(ServicesSection, null),
    React.createElement(PanelLandingSection, null),
    React.createElement(JoinSection, null),
    React.createElement(Footer, null))); };
export default hot(BotsLandingApp);
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-16tpoje" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: Inter, Roboto, sans-serif;\n  white-space: pre-wrap;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: Inter, Roboto, sans-serif;\n  white-space: pre-wrap;\n"])));
var templateObject_1;
